import { render, staticRenderFns } from "./Facturation.vue?vue&type=template&id=3b3dcf3e"
import script from "./Facturation.vue?vue&type=script&lang=js"
export * from "./Facturation.vue?vue&type=script&lang=js"
import style0 from "./Facturation.vue?vue&type=style&index=0&id=3b3dcf3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports